
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"page-status"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h5',[_v("Error 404")]),_v(" "),_c('h2',[_v("Page Not Found")]),_v(" "),_c('h4',[_v("The page you are looking for could not be found.")]),_v(" "),_c('gp-button',{on:{"click":onGoBack}},[_v("GO BACK")])],1)]),_v(" "),_c('div',{staticClass:"footer"},[_c('gpal-footer')],1)])}},
      staticRenderFns: []
    };
  